// Theme and density state for the whole app.
//
// Sets data-theme and data-density on the document root, which is what the
// tokens in styles/tokens.css key off. Defaults to light and normal.
//
// TODO(persistence): nothing is persisted yet. When user settings grow a
// theme preference, load it here and save it in setTheme and setDensity.
// Until then a reload returns to the defaults.

import { createContext, useContext, useEffect, useState } from 'react'

const ThemeContext = createContext({
  theme: 'light',
  setTheme: () => {},
  density: 'normal',
  setDensity: () => {},
})

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('light')
  const [density, setDensity] = useState('normal')

  useEffect(() => {
    document.documentElement.dataset.theme = theme
  }, [theme])

  useEffect(() => {
    document.documentElement.dataset.density = density
  }, [density])

  return (
    <ThemeContext.Provider value={{ theme, setTheme, density, setDensity }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  return useContext(ThemeContext)
}
